import { useState, useEffect } from 'react';
import { Plus, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import { billingAPI } from '../../services/billing';
import AddPaymentMethodModal from '../../components/billing/AddPaymentMethodModal';
import toast from 'react-hot-toast';

export default function PaymentMethodsPage() {
  const [methods, setMethods] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAdd, setShowAdd] = useState(false);
  const stripeConfigured = Boolean(String(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '').trim());

  const load = async () => {
    try {
      setLoading(true);
      const { data } = await billingAPI.getPaymentMethods();
      setMethods(data.paymentMethods || []);
    } catch (err) {
      console.warn(err);
      toast.error('Failed to load payment methods');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <div className="space-y-6 max-w-4xl mx-auto">
      <div className="flex items-center justify-between">
        <Link to="/invoices" className="inline-flex items-center gap-1 text-sm text-primary-600 hover:underline">
          <ArrowLeft size={16} /> Billing & Subscriptions
        </Link>
      </div>
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">Payment Methods</h1>
        <button onClick={() => setShowAdd(true)} disabled={!stripeConfigured} className="inline-flex items-center gap-2 btn-primary disabled:opacity-50 disabled:cursor-not-allowed">
          <Plus size={16} /> Add Card
        </button>
      </div>
      {!stripeConfigured && (
        <div className="rounded border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800">
          Stripe is not configured for this frontend. Set <code>VITE_STRIPE_PUBLISHABLE_KEY</code> in <code>frontend/.env</code> and restart frontend.
        </div>
      )}

      <div className="card">
        <div className="card-body">
          {loading ? (
            <div className="text-center py-12">Loading…</div>
          ) : methods.length === 0 ? (
            <div className="text-center py-12">No payment methods. Add a card to pay invoices online.</div>
          ) : (
            <ul className="space-y-3">
              {methods.map((m) => (
                <li key={m.id} className="p-3 border rounded-lg flex items-center justify-between">
                  <div>
                    <div className="font-medium">{m.card.brand.toUpperCase()} •••• {m.card.last4}</div>
                    <div className="text-sm text-gray-500">Expires {m.card.exp_month}/{m.card.exp_year}</div>
                  </div>
                  <div className="text-sm text-gray-600">{m.billing_details?.name || ''}</div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      {showAdd && <AddPaymentMethodModal onClose={() => { setShowAdd(false); load(); }} />}
    </div>
  );
}
